/**
 * A CONTINGÊNCIA DO MESTRE nas telas da cobrança (14) e dos cadastros (01),
 * 0109. Com o ERP como mestre da entidade (a matriz do 04), o banco recusa a
 * escrita direta (regra I6) com a frase "quem não é mestre não escreve: o
 * mestre de … é …". Até a 0108 as duas telas só mostravam a recusa; agora, para
 * quem tem `integracao.contingencia`, a recusa abre o campo do motivo, e a
 * mesma gravação vai de novo com ele — a função do servidor é a mesma da aba
 * Títulos e notas, e o lote seguinte do mestre casa.
 *
 * Puro (sem React nem rede): a mesa e o celular leem daqui, e o teste alcança.
 */
import { explicarFalha } from './pedido';

/** O piso do motivo, o mesmo do servidor (`MotivoDaContingencia`) e do banco. */
export const MINIMO_DA_CONTINGENCIA = 15;
export const MAXIMO_DA_CONTINGENCIA = 400;

const RECUSA_DO_MESTRE = /^quem não é mestre não escreve: o mestre de (.+) é (.+)$/i;

/** A recusa da regra I6, com a entidade e o mestre; qualquer outra falha devolve `null`. */
export function recusaDoMestre(erro: unknown): { readonly entidade: string; readonly mestre: string } | null {
  if (erro === null || erro === undefined) return null;
  const m = RECUSA_DO_MESTRE.exec(explicarFalha(erro).erro.trim());
  return m?.[1] && m[2] ? { entidade: m[1], mestre: m[2] } : null;
}

export const contingenciaValida = (motivo: string): boolean => motivo.trim().length >= MINIMO_DA_CONTINGENCIA;

/** A frase que acompanha o campo: o que acontece com a gravação em contingência. */
export function fraseDaContingencia(recusa: { readonly entidade: string; readonly mestre: string }, podeDeclarar: boolean): string {
  return podeDeclarar
    ? `O mestre de ${recusa.entidade} é ${recusa.mestre}. Se ele estiver fora do ar, grave aqui em contingência, com o motivo: o lote seguinte dele casa este registro.`
    : `O mestre de ${recusa.entidade} é ${recusa.mestre}: lance lá e importe o arquivo. A escrita em contingência é do perfil Administrador.`;
}

/** O efeito no toast (R04) da gravação que ficou em contingência. */
export const EFEITO_DA_CONTINGENCIA = 'Em contingência: o lote seguinte do mestre casa este registro';

/** Os cadastros do 01 que o ERP pode mestrar (fornecedor, cliente e centro de custo): só eles aceitam a contingência. */
export const CADASTROS_COM_MESTRE: ReadonlySet<string> = new Set(['clientes', 'fornecedores', 'centros-de-custo']);
